<template>
    <div class='login'>
        <div v-if="resource.mode === 'image'" class="login-bg animated  fast login-in"
             style="background-image: url('./img/login_bg.jpg')"></div>

        <div v-if="resource.mode === 'video'">
            <div class="login-video-div">
              <img class="" :src="loginImg" style="width: 100%;height: 100%;" alt="">
<!--              <video id="video" :poster="resource.videoPoster" loop autoplay muted/>-->
            </div>
            <div class="login-video-progress"
                 v-if="videoPercent !== 0 && videoPercent !== 100 && resource.mode === 'video'">
                <el-progress :percentage="videoPercent" :show-text="false"/>
            </div>
            <template v-if="resource.logoMode === 'image'">
              <img class="login-top-left-logo" :src="resource.logoImage" alt="" v-if="isPgswitch === '1'">
              <img class="login-top-left-logo" style="width: 240px;" :src="noLgimg" alt="" v-if="isPgswitch === '2'">
            </template>
            <div class="login-top-left-logo" v-if="resource.logoMode === 'text'">{{ resource.logoText }}</div>
            <img class="login-bottom-logo" :src="resource.bottomLogo" alt="" v-if="resource.bottomLogo && isPgswitch === '1'">
        </div>

        <div class="login-con animated fadeIn">
            <el-form class="login-form" :model="loginForm" :rules="rules" ref="loginForm">
                <h1>
                    <i class="el-icon-fa el-icon-fa-sign-in" style="margin-right: 10px;"/>欢迎登录</h1>
                <div class="input-con">
                    <el-form-item prop="userid">
                        <el-input type="text" v-model="loginForm.userid" placeholder="账号" size="large" @keyup.native.enter='handleSubmit'>
                            <i slot="prepend" class="el-icon-fa el-icon-fa-user"/>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="passwd">
                        <el-input type="password" v-model="loginForm.passwd" placeholder="密码" size="large"
                                  @keyup.native.enter='handleSubmit'>
                            <i slot="prepend" class="el-icon-fa el-icon-fa-lock"/>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="btnSubmit blue" @click.native.prevent="handleSubmit" :loading="loading">登录</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>


        <el-dialog :visible.sync="error.visible" width="355px" class="dialog-login-confirm" close-on-press-escape close-on-click-modal
                   top="calc(100vh/2 - 100px)">
            <div v-if="error.visible">
                <LoginConfirm v-bind="error"></LoginConfirm>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { config } from "cnetong-core-frontend";
import LoginApi from './Login';
import LoginConfirm from "./LoginConfirm";

export default {
    components: {LoginConfirm},
    computed: {},
    data() {
        return {
            resource: config.login,
            loginImg: require("@/assets/loginImg.jpg"),
            noLgimg: require("@/assets/noLgimg.jpg"),
            isPgswitch: null,
            videoPercent: 0,

            error: {
                visible: false,
                code: '999',
                authCode: ',',
            },
            loading: false,
            loginForm: {
                userid: "",
                passwd: "",
            },
            rules: {
                userid: [{required: true, message: "请输入账号"}],
                passwd: [{required: true, message: "请输入密码"}],
            },
            test: 2
        };
    },
    created() {
      this.initPgswitch()
    },
    mounted() {
        // this.initLoginVideo();
    },
    methods: {
        // 处理登陆按钮
        async handleSubmit() {
            try {
                this.error.message = "";
                this.error.visible = false;
                await this.$refs.loginForm.validate();
                this.loading = true;
                let resp = await LoginApi.login(this.loginForm);
                 //let resp = {
                 //    code: String(this.test++),
                 //    authCode:'12345678901234567890123456789012'
                 //}
                if (resp.code === '0') {
                    this.$message.error("登陆服务异常,请联系客服");
                } else if (resp.code === '1') {
                    window.localStorage.setItem(config.loginToken, "true");
                    this.$store.state.base.loginTimeout = false;
                    // this.$store.state.base.loginChangePwd = resp.changepwd;
                    this.$tabView.removeAll();
                    await this.$router.push("/");
                } else if (resp.code === '2') {
                    this.$message.error("企业账号密码错误,请联系客服.");
                } else if (resp.code === '3') {
                    this.$message.error("注册账号已申请,等待审批.");
                } else if (resp.code === '4') {
                    this.$message.error("注册审批未通过,请联系客服.");
                } else if (resp.code === '5') {
                    this.$message.error("登录账号已锁定,请联系客服.");
                } else if (resp.code === '15') {
                  this.$message.error("本地授权文件文件不存在,请确认授权文件是否存在.");
                  this.error.code = resp.code;
                  this.error.authCode = resp.authCode;
                  this.error.visible = true;
                }else if (resp.code === '16') {
                  this.$message.error("本地授权文件加载失败,请联系确认文件是否正确.");
                  this.error.code = resp.code;
                  this.error.authCode = resp.authCode;
                  this.error.visible = true;
                }else if (resp.code === '17') {
                  this.$message.error("本地授权文件校验,授权比对未通过,请确认.");
                  this.error.code = resp.code;
                  this.error.authCode = resp.authCode;
                  this.error.visible = true;
                }else if (resp.code === '18') {
                  this.$message.error("本地授权文件中登录用户授权信息不存在,请确认.");
                  this.error.code = resp.code;
                  this.error.authCode = resp.authCode;
                  this.error.visible = true;
                }else {
                    this.error.code = resp.code;
                    this.error.authCode = resp.authCode;
                    this.error.visible = true;
                }
            } catch ( e ) {
                this.$message.error(e.message);
            } finally {
                this.loading = false;
            }
        },
        async initPgswitch() {
          try {
            let res = await LoginApi.pgswitch();
            if (res) {
              this.isPgswitch = res.pageSwitch
              localStorage.setItem("isPgswitch", this.isPgswitch);
            }
          } catch ( e ) {
            this.$message.error(e.message);
          }
        },
        initLoginVideo() {
            if (this.resource.mode === 'video') {
                let xhr = new XMLHttpRequest();
                xhr.open("GET", this.resource.video, true);
                xhr.addEventListener("progress", evt => {
                    if (evt.lengthComputable) {
                        let percentComplete = evt.loaded / evt.total;
                        this.videoPercent = percentComplete * 100;

                    }
                }, false);
                xhr.responseType = "blob";
                xhr.onload = e => {
                    if (e.target.status === 200) {
                        let b = e.target.response;
                        let vid = (window.webkitURL || window.URL).createObjectURL(b);
                        let video = document.getElementById("video");
                        video.src = vid;
                        video.play();
                    }
                };
                xhr.send();
            }
        },
    }
}
;
</script>
<style lang="scss">
.dialog-login-confirm {

    .el-dialog {
        border: 0;

        .el-dialog__header {
            display: none;
        }

        .el-dialog__body {
            padding: 1px;
        }
    }
}

.login {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .login-video-div {
        position: fixed;
        height: 70%;
        width: 100%;
        top: calc((100vh - 70%) / 2);
        overflow: hidden;

        video {
            width: 100%;
        }
    }

    .login-video-progress {
        position: fixed;
        width: 100%;
        top: calc(100vh - 15%);

        .el-progress-bar__outer {
            border-radius: 0;
            height: 2px !important;
        }

        .el-progress-bar__inner {
            border-radius: 0;
        }
    }

    .login-top-left-logo {
        background-size: 523px 60px;
        height: 60px;
        width: 523px;
        position: fixed;
        top: calc(100vh - 70% - 15% + -70px);
        left: 160px;
        font-size: 36px;
        color: #0068b5;
    }

    .login-bottom-logo {
        width: 299px;
        height: 38.5px;
        background-size: 299px 38.5px;
        position: fixed;
        top: calc(100vh - 15% + 28px);
        right: 160px;
    }
}

.login-bg {
    background-size: cover;
    position: absolute;
    width: 100%;
    height: 100%;
}

@keyframes login-in {
    100% {
        transform: scale(1, 1);
        opacity: 1;
    }
    0% {
        transform: scale(1.4, 1.4);
        opacity: 0;
    }
}

.login-in {
    animation-name: login-in;
}

.login-con {
    position: absolute;
    right: 160px;
    top: 50%;
    -webkit-transform: translateY(-60%);
    transform: translateY(-60%);
    width: 300px;
    min-height: 200px;
    background-color: #fff;
    border-radius: 4px;

    .login-form {
        box-shadow: none;

        h1 {
            height: 30px;
            line-height: 30px;
            margin: 0;
            font-size: 12px;
            padding-left: 30px;
            padding-bottom: 5px;
            padding-top: 5px;
            border-bottom: 1px solid #ccc;
        }

        .input-con {
            padding: 15px 20px 0 20px;
        }

        .el-form-item {
            border-radius: 4px;
            margin-bottom: 1em;
        }

        .el-icon-fa::before {
            font-size: 15px;
        }

        input {
            height: 30px;
            line-height: 30px;
            background-color: #fff !important;
            padding-left: 12px;
        }

        .el-input-group__prepend {
            width: 20px;
            text-align: center;
        }

        .btnSubmit {
            height: 30px;
            width: 100%;
        }
    }

    .captcha {
        cursor: pointer;
        height: 20px;
    }
}
</style>
